import React, { createContext, useCallback, useContext, useState } from 'react';

type Toast = { id: number; text: string; bad?: boolean };
const Ctx = createContext<{ push: (t: string, bad?: boolean) => void }>({ push: () => {} });
export const useToast = () => useContext(Ctx);

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const [list, setList] = useState<Toast[]>([]);

  const push = useCallback((text: string, bad?: boolean) => {
    const id = Date.now() + Math.random();
    setList(l => [...l, { id, text, bad }]);
    setTimeout(() => setList(l => l.filter(t => t.id !== id)), 3400);
  }, []);

  return (
    <Ctx.Provider value={{ push }}>
      {children}
      <div className="fixed left-1/2 -translate-x-1/2 bottom-[110px] md:bottom-6 z-[95] flex flex-col gap-2 items-center pointer-events-none">
        {list.map(t => (
          <div key={t.id}
            className={`card-dark px-4 py-2.5 flex items-center gap-2.5 font-mono text-[12px] font-bold uppercase tracking-wider
              ${t.bad ? 'text-danger border-danger/40' : 'text-cream'}`}>
            {!t.bad && <span className="status-dot" />}
            {t.text}
          </div>
        ))}
      </div>
    </Ctx.Provider>
  );
}
